// Batch 34 · fork A — Z-11 (sampling population period), B34-8 (substantive work per head, "no further substantive work"),
// B34-9 (support reference typed by user), B34-10 (amount per support document, difference). EN + AR.
export const I18N_B34A = {
  en: {
    b34a: {
      popPeriod: "Population: current period {label}",
      popPriorExcluded: "{n} prior-year row(s) left out",
      refTyped: "typed by user",
      refTypedTitle: "Typed by the user — overrides the linked documents' reference. Clear it to return to the documents' reference.",
      docAmount: "Amount per support document",
      docAmountHint: "Net of VAT; a VAT line is compared with the document's VAT; a receivable, payable or bank line with the document's gross total.",
      difference: "Difference",
      differenceHint: "Row amount − amount per support document. Flagged when not nil; stronger colour at or above clearly trivial.",
      basis_net: "net", basis_vat: "VAT", basis_gross: "gross",
      notRead: "not read",
      amountTyped: "typed by user",
      amountOverride: "Override the amount (empty = from the document)",
      amountSaved: "Amount saved",
      saveFailed: "Could not save",
      nfwTitle: "No further substantive work",
      nfwHelp: "A reviewer can record why this head needs no further substantive work. It counts for the lock only with the lead-sheet conclusion saved.",
      nfwReason: "Reason",
      nfwSign: "Sign the reason",
      nfwWithdraw: "Withdraw",
      nfwSignedBy: "Signed by {name} on {date}",
      nfwOnlyReviewer: "Only a Reviewer, a Supervisor, a Manager (Assistant, Senior or Audit Manager), a Director, a Partner or the Firm Admin can sign this reason.",   // Batch 35 · P53-R3: the real role list
      nfwSaved: "Reason signed",
    },
  },
  ar: {
    b34a: {
      popPeriod: "المجتمع: الفترة الحالية {label}",
      popPriorExcluded: "استُبعد {n} صف/صفوف من السنة السابقة",
      refTyped: "أدخله المستخدم",
      refTypedTitle: "أدخله المستخدم — يحل محل مرجع المستندات المرتبطة. امسحه للعودة إلى مرجع المستندات.",
      docAmount: "المبلغ حسب المستند المؤيد",
      docAmountHint: "صافٍ من ضريبة القيمة المضافة؛ يُقارن سطر الضريبة بضريبة المستند، وسطر الذمم المدينة أو الدائنة أو البنك بإجمالي المستند.",
      difference: "الفرق",
      differenceHint: "مبلغ الصف − المبلغ حسب المستند المؤيد. يُميَّز إذا لم يكن صفراً؛ ولون أقوى عند بلوغ الحد التافه بوضوح أو تجاوزه.",
      basis_net: "صافٍ", basis_vat: "الضريبة", basis_gross: "إجمالي",
      notRead: "لم يُقرأ",
      amountTyped: "أدخله المستخدم",
      amountOverride: "تعديل المبلغ (فارغ = من المستند)",
      amountSaved: "حُفظ المبلغ",
      saveFailed: "تعذّر الحفظ",
      nfwTitle: "لا عمل جوهري إضافي",
      nfwHelp: "يمكن للمراجع تسجيل سبب عدم حاجة هذا البند إلى عمل جوهري إضافي. لا يُحتسب للقفل إلا مع حفظ استنتاج الورقة الرئيسية.",
      nfwReason: "السبب",
      nfwSign: "توقيع السبب",
      nfwWithdraw: "سحب",
      nfwSignedBy: "وقّعه {name} في {date}",
      nfwOnlyReviewer: "لا يوقّع هذا السبب إلا المراجع أو المشرف أو المدير (مساعد المدير أو المدير الأول أو مدير المراجعة) أو المدير التنفيذي أو الشريك أو مسؤول الشركة.",
      nfwSaved: "تم توقيع السبب",
    },
  },
};

export default I18N_B34A;
